module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC/SURBVEhLtZbBDQIxDARTBP0XAHRHAVxWukiOY0/MnRhpH/HEK3jlmuHR8+759HxdMvw97apDXQuvHr8wkhHdVdS1EP3yq1HXQnTxThZQFsEOlEWwg2Q0t/eH8+cJkumSgzpCaWc2GXgnknZmI3azBZLpkoM6UKZLDupgGWDvjx1/nkBZBDtQFsGOSNrZLsKfJ1AWwQ6URbAjkna2i/DnCZRFsANlEez4+5NJj/6vCR99fWpI3Pkn2n32nJ8trR3zpxRJUEOTewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu/treatment.png
// module id = 55
// module chunks = 0